// American wheel order (clockwise)
export const ORDER = [0,28,9,26,30,11,7,20,32,17,5,22,34,15,3,24,36,13,1,'00',27,10,25,29,12,8,19,31,18,6,21,33,16,4,23,35,14,2];
export const REDS = new Set([1,3,5,7,9,12,14,16,18,19,21,23,25,27,30,32,34,36]);
export const CHIPS = [{ v: 1, c: 'c1' }, { v: 10, c: 'c10' }, { v: 100, c: 'c100' }, { v: 500, c: 'c500' }];
export const START_BALANCE = 2500;
export const DEFAULT_CHIP = 10;
export const HISTORY_LIMIT = 10;
export const DEFAULT_MESSAGE = 'Place Your Bets';
